module.exports = __webpack_public_path__ + "static/img/slide-1-plus.da8ac63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-1-plus.svg
// module id = FrUB
// module chunks = 1